import { OrderPriceChangeReason } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getOrderPriceEditFormSchema = () => {
	return z.object({
		price: z.number(),
		reason: z.nativeEnum(OrderPriceChangeReason),
		materialPrice: z.number().nullish(),
	});
};

export type OrderPriceEditFormModel = z.infer<
	ReturnType<typeof getOrderPriceEditFormSchema>
>;
